const footerLinks = {
  热门分类: ['热播电视剧', '院线大片', '热门综艺', '动漫番剧', '古装武侠', '悬疑推理'],
  关于平台: ['关于我们', '最新动态', '常见问题', '联系我们', '用户协议', '隐私政策'],
  合作伙伴: [],
};

export default function Footer() {
  return (
    <footer id="footer" className="bg-foreground-900 text-background-50/80">
      <div className="max-w-6xl mx-auto px-4 md:px-6 py-14 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="md:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500">
                <i className="ri-movie-2-line text-background-50 text-lg"></i>
              </div>
              <span className="text-lg font-bold text-background-50 font-heading tracking-wide whitespace-nowrap">
                91影视看片
              </span>
            </div>
            <p className="text-sm text-background-50/60 leading-relaxed mb-6">
              91影视看片app✨提供免费影视在线观看服务，覆盖热门电视剧、电影、综艺高清片源。无需付费、不用缓冲，打开即看最新高清免费看片内容，打造你的专属免费追剧平台。
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-50/10 hover:bg-primary-500 transition-colors cursor-pointer">
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-50/10 hover:bg-primary-500 transition-colors cursor-pointer">
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-50/10 hover:bg-primary-500 transition-colors cursor-pointer">
                <i className="ri-bilibili-line text-sm"></i>
              </a>
            </div>
          </div>

          {Object.entries(footerLinks).map(([title, links]) => (
            <div key={title}>
              <h3 className="text-sm font-bold text-background-50 mb-5 whitespace-nowrap">{title}</h3>
              {links.length > 0 ? (
                <ul className="space-y-3">
                  {links.map((link) => (
                    <li key={link}>
                      <a href="#" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">
                        {link}
                      </a>
                    </li>
                  ))}
                </ul>
              ) : (
                <p className="text-sm text-background-50/40">暂无具体合作伙伴信息</p>
              )}
            </div>
          ))}
        </div>

        <div className="mt-12 pt-8 border-t border-background-50/10">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-50/40 text-center sm:text-left">
              &copy; 2026 91影视看片app. 本站所有内容均为用户推荐与信息聚合，仅供学习交流使用。
            </p>
            <p className="text-xs text-background-50/30 whitespace-nowrap">
              京ICP备XXXXXXXX号
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}